import { useEffect, useState } from "react";
import { SharedRepository } from "../../api/repositories/cdn/shared";
import { PageContainer } from "../components/layout/page";
import { useParams } from "react-router-dom";
import { SubscribeGlobalState } from "../../common/hooks/global-state";
import { HeroShared } from "../../api/repositories/cdn/models/shared";
import { HeroImage } from "../components/ui/file-contents";
import { Tooltip } from 'react-tooltip';
import { SharedHeroTalent } from "../../common/constants";
import { HeroTemplateBlock } from "../components/layout/blocks";
import { NotFoundBlock } from "../components/layout/errors";
import { HeroDetailsBlock } from "../components/blocks/hero/hero-details";
import { ItemBuildsBlock } from "../components/blocks/hero/item-builds";
import { UpgradeChangesBlock } from "../components/blocks/hero/upgrade-changes";
import { ChangesBlock } from "../components/blocks/hero/changes-block";
import { DarkTooltip } from "../components/ui/other";
import { LoadingIcon } from "../components/ui/icons";

export const Hero: React.FC = () => {
    const { name } = useParams();
    const heroes = SubscribeGlobalState('heroes')
    const language = SubscribeGlobalState('language')

    const hero = heroes?.find(f => f.urlName == name);

    const [heroShared, setHeroShared] = useState<HeroShared | undefined>();
    const [gotResponse, setGotResponse] = useState<boolean>(false);

    useEffect(() => {
        if (hero) {
            const repository = new SharedRepository();

            repository.getHero(hero.name, language ?? 'en')
                .then(t => setHeroShared(t))
                .then(t => setGotResponse(true));
        }

    }, [name]);

    const heroNotFoundBlock = <NotFoundBlock
        localText="hero_not_found_title"
        onClickBtn={() => window.location.href = '/heroes'}
        btnLocalText="hero_not_found_btn"
        withImg={false}
    />

    return (
        <PageContainer
            containerClassName=" min-h-[350px] mt-[60px]"
            headerImgPath="/v2/images/bg/dragon.png"
            child={
                hero
                    ? gotResponse
                        ? heroShared
                            ? <HeroContainer hero={hero} heroDetails={heroShared} />
                            : heroNotFoundBlock
                        : <LoadingIcon />
                    : heroNotFoundBlock
            }
        />
    );
}

const HeroContainer: React.FC<{
    hero: Hero
    heroDetails: HeroShared
}> = ({ heroDetails, hero }) => {
    const isNewGen = SharedHeroTalent in heroDetails.purpleTalents;

    return (
        <div className="flex flex-col lg:w-[1560px] w-full mx-auto items-center lg:items-start gap-[14px]">
            <div className="h-auto lg:h-[125px] flex flex-col lg:flex-row items-center lg:items-center gap-[24px] lg:gap-[32px] text-center lg:text-left">
                {!isNewGen && <HeroImage heroName={hero.name} size="146x82" />}
                <span className="text-[28px] lg:text-[36px] font-semibold uppercase">
                    {hero.userFriendlyName}
                </span>
            </div>

            <HeroTemplateBlock
                className={`${isNewGen ? '' : 'mt-[32px]'} bg-dark-opacity`}
                child={<HeroDetailsBlock isNewGen={isNewGen} hero={hero} heroDetails={heroDetails} />}
            />
            <ItemBuildsBlock hero={hero} heroDetails={heroDetails} />
            <HeroTemplateBlock child={<UpgradeChangesBlock hero={hero} upgrades={heroDetails.upgrades} />} />
            <HeroTemplateBlock child={<ChangesBlock hero={hero} changes={heroDetails.changes} />} />
            <DarkTooltip id="talent" />
        </div>
    );
};


const EmptyHeroContainer: React.FC = () => {
    return <div className="w-full flex flex-col justify-start gap-[14px]">
        <div className="h-[125px] flex items-center " />
        <HeroTemplateBlock className={`h-[456px]`} />
        <HeroTemplateBlock className={`h-[432px]`} />
        <HeroTemplateBlock className={`h-[800px]`} />
        <HeroTemplateBlock className={`h-[600px]`} />
        <Tooltip className="z-10 w-fit bg-dark max-w-[30rem] font-['Roboto']" id='talent' />
    </div>
}


